import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators, FormControl } from '@angular/forms';
import { environment } from "./../../../environments/environment";
import { CustomValidators } from 'ng2-validation';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Router, ActivatedRoute, NavigationStart, NavigationEnd } from '@angular/router';
import { SubscribeService } from '../service/subscribeService.service';

import { RoleService } from 'src/app/services/role.service';
@Component({
  selector: 'page-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  providers: [MessageService],
})
export class FooterComponent implements OnInit {

   position: 'left' | 'right' | 'top' | 'bottom' | 'center' | 'topleft' | 'topright' | 'bottomleft' | 'bottomright' = 'center';
       public downloadModal: boolean = false;
  subscribeForm: FormGroup;
  submitted: boolean;
  public currentYear= (new Date()).getFullYear();
  public errorMessage: string;
  showSuccess: boolean = false;
  usercategories: any;
  public roleFilteredArr;
  currentActiveRoute: string | null;
  aboutTpl: boolean = false;
  constructor(private formBuilder: FormBuilder, private messageService: MessageService, private router: Router, private subscribeService: SubscribeService, 
    private roleService: RoleService, private activatedRoute:ActivatedRoute) { }

  ngOnInit(): void {
    setTimeout(()=>{
    this.aboutTpl = JSON.parse(window.localStorage.getItem('AboutTpl'));
    this.getCurrentActiveRoute();
    });
    this.router.events.subscribe((events:any)=>{
      if(events instanceof NavigationEnd) {
        if(events.url.includes('/tournaments') || events.url.includes('/academies/academydetails') 
          || events.url.includes('/my-schedule') || events.url.includes('/leaderboard') || events.url.includes('/find-partner')
          || events.url.includes('/about-the-league') || events.url.includes('/scoretable')
          || events.url.includes('/teams') || events.url.includes('/sponsors')
          || events.url.includes('/media') || events.url.includes('/highlights')
          || events.url.includes('/home') || events.url.includes('/contest')
          || events.url.includes('/product') || events.url.includes('/academies')) {
          setTimeout(()=>{
            this.getCurrentActiveRoute();
          },0);
        }
      }
      setTimeout(()=>{
        this.aboutTpl = JSON.parse(window.localStorage.getItem('AboutTpl'));
      },0);
    })

    this.roleFilteredArr = environment.roleFilteredArray;
    this.getRoles();
    this.subscribeForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email, CustomValidators.email]]
    });
  }

  getCurrentActiveRoute() {
    const currentRouteObj = JSON.parse(window.localStorage.getItem((!this.aboutTpl) ? 'currentRouteObj1' : 'currentRouteObj2'));
    const findCurrentActiveRoute = Object.entries(currentRouteObj).find(ele=> ele[1] === true ) ?? null;
    this.currentActiveRoute = Array.isArray(findCurrentActiveRoute) ? findCurrentActiveRoute[0] : null;
  }

  onClickCurrentTab(url:string) {
    if(url === '/tournaments') {
      let initialTournamentPaginationvalues = { page: 1, limit: 10, tab: 2 }
      window.localStorage.setItem('tournament-pagination',JSON.stringify(initialTournamentPaginationvalues));
    }
    this.roleService.setCurrentActiveRoute(url);
    setTimeout(()=>{
      this.getCurrentActiveRoute();
    },0);
  }

  get f() {
    return this.subscribeForm.controls;
  }

  getRoles() {
    let query = "filterByDisable=false";
    this.roleService.getRoleListWithoutAuth(query).subscribe(data => {
      if (data.data.items) {
        let rolesArray = data.data.items;
        let rIndex = this.findSelectedIndexByRole('coach', rolesArray);
          if (rIndex != -1) {
            //rolesArray.splice(rIndex, 1);
            this.usercategories = rolesArray[rIndex];     
            this.playercategory= this.usercategories.id;  
          }
        
      }
    })
  }

  playercategory: any
  onClick() {
    
    this.subscribeService.passpartnerID(this.playercategory);
    this.router.navigate(['find-partner'])
  }
  findSelectedIndexByRole(role, arrayName) {
    let index = -1;
    for (let i = 0; i < arrayName.length; i++) {
      if (arrayName[i].user_role_name === role) {
        index = i;
        break;
      }
    }
    return index;
  }


  onSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.subscribeForm.invalid) {
      return;
    }
    let subscribeData = this.subscribeForm.value;
    this.subscribeService.add(subscribeData).subscribe(res => {
      this.showSuccess = true;
      //this.messageService.add({key: 'bc', severity: 'success', summary: 'Successful', detail: 'Subscribe Successfully.', life: 2000});
      setTimeout(() => {
        // this.router.navigateByUrl("/footer");
        this.submitted = false;
        this.subscribeForm.reset();
      }, 300);
    },
      ((err) => {
        this.messageService.add({ key: 'toastmsg', severity: 'error', summary: "Error", detail: 'Failed to Subscribe', life: 6000 });
      })
    );
  }
onDownloadClick(position: 'left' | 'right' | 'top' | 'bottom' | 'center' | 'topleft' | 'topright' | 'bottomleft' | 'bottomright'){
  this.position = position;
  this.downloadModal = true; 
}
}
